import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { useFormSubmit } from "./useFormSubmit";

import { clearForm } from "../slices/formSlice";
import { loginUser } from "../slices/authSlice";
import { logoutUser } from "../slices/authSlice";
import { closeDrawer } from "../slices/drawerSlice";

export const useAuthForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const formId = "authForm";
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const error = useSelector((state) => state.auth.error);
    const loadingStatus = useSelector((state) => state.auth.loadingStatus);

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(clearForm());
            navigate('/Departures');
        }
    }, [dispatch, isAuthenticated, navigate]);

    const { handleSubmit } = useFormSubmit({
        formId,
        onSubmit: async (formValues) => {
            const action = await dispatch(loginUser(formValues));
            if (loginUser.fulfilled.match(action)) {
                dispatch(clearForm({formId}));
            } else {
                throw action.payload || action.error;
            }
        },
        successMessage: "Вы успешно вошли в систему",
        fields: [
            {name: "email", label: "Почта"},
            {name: "password", label: "Пароль"}
        ],
        error
    });

    const handleLogout = () => {
        dispatch(logoutUser());
        dispatch(closeDrawer());
    }

    return {formId, loadingStatus, handleLogin: handleSubmit, handleLogout: handleLogout}
}